import React, { useState } from "react";
import { collection, doc, setDoc, Timestamp } from "firebase/firestore";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "../../firebase/config";

export default function CreateUser() {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    company: "",
    email: "",
    role: "client",
    password: "", // ✅ le champ mot de passe est bien là
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!form.password || form.password.length < 6) {
        alert("Le mot de passe provisoire doit contenir au moins 6 caractères.");
        return;
      }

      const userCredential = await createUserWithEmailAndPassword(
        auth,
        form.email,
        form.password
      );
      const user = userCredential.user;

      await setDoc(doc(db, "users", user.uid), {
        firstName: form.firstName,
        lastName: form.lastName,
        company: form.company,
        email: form.email,
        role: form.role,
        nom: `${form.firstName} ${form.lastName}`.trim(),
        displayName: `${form.firstName} ${form.lastName}`.trim(),
        createdAt: Timestamp.now(),
        active: true,
      });

      alert(
        `✅ Utilisateur créé !\n\nMot de passe provisoire : ${form.password}`
      );

      setForm({
        firstName: "",
        lastName: "",
        company: "",
        email: "",
        role: "client",
        password: "",
      });
    } catch (error) {
      console.error("❌ Erreur lors de la création :", error);
      alert("Erreur de création : " + error.message);
    }
  };

  return (
    <div className="max-w-xl mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h2 className="text-2xl font-bold mb-6 text-center">
        Créer un Utilisateur
      </h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Prénom *
          </label>
          <input
            name="firstName"
            value={form.firstName}
            onChange={handleChange}
            placeholder="Prénom"
            className="w-full border border-gray-300 p-3 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Nom *
          </label>
          <input
            name="lastName"
            value={form.lastName}
            onChange={handleChange}
            placeholder="Nom"
            className="w-full border border-gray-300 p-3 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Entreprise
          </label>
          <input
            name="company"
            value={form.company}
            onChange={handleChange}
            placeholder="Nom de l'entreprise"
            className="w-full border border-gray-300 p-3 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Email *
          </label>
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="adresse@email.com"
            className="w-full border border-gray-300 p-3 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Mot de passe provisoire *
          </label>
          <input
            type="text"
            name="password"
            value={form.password}
            onChange={handleChange}
            placeholder="Ex: Azerty123!"
            className="w-full border border-gray-300 p-3 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Rôle *
          </label>
          <select
            name="role"
            value={form.role}
            onChange={handleChange}
            className="w-full border border-gray-300 p-3 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">Sélectionnez un rôle</option>
            <option value="superadmin">Super Admin</option>
            <option value="projectmanager">Chef de Projet</option>
            <option value="charge-affaire">Chargé(e) d'affaire</option>
            <option value="client">Client</option>
          </select>
        </div>

        <button
          type="submit"
          className="w-full bg-blue-600 text-white px-4 py-3 rounded-lg hover:bg-blue-700 transition duration-200 font-medium"
        >
          Créer l'utilisateur
        </button>
      </form>
    </div>
  );
}
